(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[138],{

/***/ "/5rO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./src/store/modules/root/actions.js
var actions = __webpack_require__("6Kk0");

// EXTERNAL MODULE: ./node_modules/react-geocode/lib/index.js
var lib = __webpack_require__("s3JR");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/atomic/common/Rows/index.js
var Rows = __webpack_require__("cK8a");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./src/atomic/globals/index.js + 3 modules
var globals = __webpack_require__("BlcV");

// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/Neighborhoods/styles.js


var NeighborhoodContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__NeighborhoodContainer",
  componentId: "sc-6ozr4s-0"
})(["width:calc(100% - 50px);margin:0 auto;@media only screen and (min-width:992px){width:70%;min-width:350px;max-width:830px;}"]);
var CityButtonGroup = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__CityButtonGroup",
  componentId: "sc-6ozr4s-1"
})(["width:100%;display:flex;flex-flow:row wrap;justify-content:flex-start;margin-bottom:27px;border-bottom:1px solid #EAEAEA;"]);
var CityButton = styled_components_browser_esm["b" /* default */].button.withConfig({
  displayName: "styles__CityButton",
  componentId: "sc-6ozr4s-2"
})(["cursor:pointer;width:max-content;", " padding:26px 36px;color:", ";font-family:", ";font-size:20px;&:focus{outline:none;}@media only screen and (max-width:900px){padding:20px 27px;font-size:15px;}"], function (props) {
  return !!props.selected && Object(styled_components_browser_esm["a" /* css */])(["border-bottom:4px solid ", ";"], globals["a" /* COLORS */].primary);
}, function (props) {
  return props.selected ? globals["a" /* COLORS */].primary : "#B4B4B4";
}, globals["b" /* FONTS */].family.roboto_medium);
var NeighborhoodButtonGroup = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__NeighborhoodButtonGroup",
  componentId: "sc-6ozr4s-3"
})(["width:100%;display:flex;flex-flow:row wrap;justify-content:flex-start;"]);
var NeighborhoodButton = styled_components_browser_esm["b" /* default */].button.withConfig({
  displayName: "styles__NeighborhoodButton",
  componentId: "sc-6ozr4s-4"
})(["cursor:pointer;width:max-content;margin:10px 15px 10px 0;border:1px solid #E4E4E4;border-radius:12px;box-sizing:border-box;padding:17px 23px;&:focus{outline:none;}@media only screen and (max-width:900px){font-size:12px;}"]);
// EXTERNAL MODULE: ./src/atomic/organisms/LandingPage/styles.js
var styles = __webpack_require__("Vzbl");

// CONCATENATED MODULE: ./src/atomic/organisms/LandingPage/Neighborhoods/index.js




var __jsx = react_default.a.createElement;









var Neighborhoods_Neighborhoods = function Neighborhoods(_ref) {
  var data = _ref.data;
  var neighborhoodGroupRef = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(Object.keys(data)[0]),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      processing = _useState2[0],
      setProcessing = _useState2[1];

  var dispatch = Object(es["c" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();

  var handleClickCity = function handleClickCity(city) {
    setSelected(city);
    var boundings = neighborhoodGroupRef.current.getBoundingClientRect();
    window.scrollBy({
      top: boundings.y - 200,
      behavior: "smooth"
    });
  };

  var handleClickNeighborhood = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(city, neighborhood) {
      var address, resp, _resp$results$0$geome, lat, lng;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (processing) {
                _context.next = 7;
                break;
              }

              setProcessing(true);
              address = "".concat(neighborhood, ", ").concat(city);
              _context.next = 5;
              return lib_default.a.fromAddress(address);

            case 5:
              resp = _context.sent;

              if (resp.status === "OK") {
                _resp$results$0$geome = resp.results[0].geometry.location, lat = _resp$results$0$geome.lat, lng = _resp$results$0$geome.lng;
                dispatch(Object(actions["q" /* setLocation */])({
                  address: resp.results[0].formatted_address,
                  latitude: lat,
                  longitude: lng
                }));
                router.push("/busca/localizacao");
              } else {
                setProcessing(false);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClickNeighborhood(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return __jsx(NeighborhoodContainer, null, __jsx(Rows["a" /* default */], {
    paddingDesktopTop: 140,
    paddingTop: 90
  }, __jsx(styles["c" /* Title */], {
    fontSize: 34,
    fontSizeMobile: 28
  }, "Bairros que atendemos")), __jsx(CityButtonGroup, null, Object.keys(data).map(function (city, idx) {
    return __jsx(CityButton, Object(esm_extends["a" /* default */])({}, idx === 0 ? {
      id: "landing-page-first-city-option"
    } : {}, {
      key: idx,
      selected: city === selected,
      onClick: function onClick() {
        return handleClickCity(city);
      }
    }), city);
  })), __jsx(NeighborhoodButtonGroup, {
    ref: neighborhoodGroupRef
  }, selected && data[selected].map(function (neighborhood, idx) {
    return __jsx(NeighborhoodButton, Object(esm_extends["a" /* default */])({}, idx === 0 ? {
      id: "landing-page-first-neighborhood-option"
    } : {}, {
      key: idx,
      onClick: function onClick() {
        return handleClickNeighborhood(selected, neighborhood);
      }
    }), neighborhood);
  })));
};

/* harmony default export */ var LandingPage_Neighborhoods = __webpack_exports__["default"] = (Neighborhoods_Neighborhoods);

/***/ })

}]);